import React, { Component } from 'react';

class IconTicketWifi extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none" viewBox="0 0 27 27">
                <path fill="#fff" d="M13.521 4.72c4.058-.05 7.688 1.151 10.833 3.732.742.607.849 1.019.444 1.466-.358.398-.833.333-1.495-.21a14.302 14.302 0 00-9.616-3.36A14.33 14.33 0 004.723 9.62c-.143.116-.283.232-.429.343-.402.303-.817.324-1.165-.054-.389-.424-.259-.838.135-1.19a15.724 15.724 0 014.271-2.688 16.336 16.336 0 015.986-1.311z"
                ></path>
                <path fill="#fff" d="M21.305 14.143a6.932 6.932 0 01-.778-.463c-3.939-3.19-9.18-3.193-13.127 0-.542.44-1.074.46-1.388.057-.314-.404-.205-.872.358-1.34a11.962 11.962 0 017.589-2.713c2.768 0 5.45.96 7.588 2.713.37.31.71.652.444 1.156-.125.233-.431.378-.686.59zM13.91 14.65c1.371-.04 2.724.32 3.893 1.034.648.388.82.825.519 1.27-.374.53-.841.423-1.324.15-2.013-1.149-4.028-1.149-6.043 0-.625.348-1.144.276-1.375-.203-.288-.592.073-.93.542-1.215a7.024 7.024 0 013.789-1.037zM13.929 22.05a1.091 1.091 0 01-1.038-1.136 1.061 1.061 0 01.68-1.001 1.073 1.073 0 011.399.644c.047.135.066.279.056.422a1.08 1.08 0 01-1.097 1.07z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketWifi;